<form [formGroup]="addAccountForm" class="tw-relative">
  <div>

    <mat-icon (click)="closeForm()" class="close-form">cancel</mat-icon>

    <p class="tw-text-[15px] tw-pt-[55px]">
      {{ 'ui.funding.to.prevent.funding.delays.please.verify' | translate: 'To prevent funding delays, please verify that your Routing Number is in correct.' }}
    </p>

    <p class="tw-text-[15px] tw-mt-[15px]">
      <span class="tw-font-bold">{{ 'ui.funding.click.here' | translate: 'Click here:' }} </span><br>
      <span class="tw-text-[13px]">
        <a
          href="https://www.frbservices.org/EPaymentsDirectory/search.html"
          target="_blank"
          clas="tw-underline"
        >
          https://www.frbservices.org/EPaymentsDirectory/search.html
        </a>
      </span>
    </p>

    <p class="tw-text-[15px] tw-mt-[15px]">
      <span class="tw-font-bold">{{ 'ui.funding.notice' | translate: 'NOTICE:' }}</span> {{ 'ui.funding.pre.loaded.debit.cards.not.accepted' | translate: 'Pre-loaded debit cards not accepted' }}
    </p>

    <div class="account-row tw-relative tw-mt-[25px]">
      <!-- Message section -->
      <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['bankName'] && formVal['bankName'].hasError('required')
            && (formVal['bankName'].touched || formVal['bankName'].dirty)"
        >
          {{ 'ui.funding.required.bank.name' | translate: 'Required Bank Name' }}
        </span>
      </span>

      <p class="tw-text-[16px]">{{ 'account.funding.bank.add.name' | translate: 'Bank Name' }}</p>
      <input
        formControlName="bankName"
        id="bankName"
        type="text"
        class="tw-h-[38px] tw-text-[16px] tw-text-[#645858]"
      />
    </div>

    <div class="account-row tw-relative tw-mt-[22px]">
      <!-- Message section -->
      <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['routingName']
            && (formVal['routingName']?.errors
                || addAccountForm.get('routingName')?.hasError('invalidCharacters')
                || addAccountForm.get('routingName')?.hasError('minlength')
                || addAccountForm.get('routingName')?.hasError('maxlength')
              )
            && (formVal['routingName'].touched || formVal['routingName'].dirty)"
        >
          {{
            addAccountForm.get('routingName')?.hasError('invalidCharacters')
              ? ('ui.funding.enter.valid.number' | translate: 'Please enter a valid number.')
              : addAccountForm.get('routingName')?.hasError('minlength') ||
                addAccountForm.get('routingName')?.hasError('maxlength')
                ? ('ui.funding.enter.9.digits' | translate: 'Please enter 9 digits.')
                : ('ui.funding.required.routing.number' | translate: 'Required Routing Number.')
          }}
        </span>


      </span>

      <p class="tw-text-[16px]">{{ 'account.funding.deposit.wire.routingnum' | translate: 'Routing Number' }}</p>
      <input
        formControlName="routingName"
        inputmode="numeric"
        id="routingName"
        type="text"
        class="tw-h-[38px] tw-text-[16px] tw-text-[#645858]"
      />
    </div>

    <div class="account-row tw-relative tw-mt-[22px]">
      <!-- Message section -->
      <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['accountType'] && formVal['accountType'].hasError('required')
            && (formVal['accountType'].touched || formVal['accountType'].dirty)"
        >
          {{ 'ui.funding.required.account.type' | translate: 'Required Account Type' }}
        </span>
      </span>

      <p class="tw-text-[16px]">{{ 'account.funding.bank.add.accttype' | translate: 'Account Type' }}</p>
      <select
        formControlName="accountType"
        id="accountType"
      >
        <option value="PC" selected="true">{{ 'account.funding.bank.add.checking' | translate: 'Checking' }}</option>
        <option value="PS">{{ 'account.funding.bank.add.savings' | translate: 'Savings' }}</option>
      </select>
    </div>

    <div class="account-row tw-relative tw-mt-[22px]">
      <!-- Message section -->
      <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['accountNumber']
            && (formVal['accountNumber']?.errors
                || addAccountForm.get('accountNumber')?.hasError('invalidCharacters')
                || addAccountForm.get('accountNumber')?.hasError('maxlength')
              )
            && (formVal['accountNumber'].touched || formVal['accountNumber'].dirty)"
        >
          {{
            addAccountForm.get('accountNumber')?.hasError('invalidCharacters')
              ? ('ui.funding.enter.valid.number' | translate: 'Please enter a valid number.')
              : addAccountForm.get('accountNumber')?.hasError('maxlength')
                ? ('ui.funding.enter.max.20.characters' | translate: 'Please enter no more than 20 characters.')
                : addAccountForm.get('accountNumber')?.hasError('minlength')
                  ? ('ui.funding.enter.min.6.characters' | translate: 'Please enter at least 6 characters.')
                  : ('ui.funding.required.account.number' | translate: 'Required Account Number.')
          }}
        </span>

      </span>

      <p class="tw-text-[16px]">{{ 'account.funding.bank.add.acctnum' | translate: 'Account Number' }}</p>
      <input
        formControlName="accountNumber"
        inputmode="numeric"
        id="accountNumber"
        type="text"
        class="tw-h-[38px] tw-text-[16px] tw-text-[#645858]"
      />
    </div>

    <div class="account-container">
      <button
        (click)="addAccount()"
        [ngClass]="
          {'active': (tmsId && isAgree && !isProcessing && this.addAccountForm.valid)}
        "
        [disabled]="!tmsId || !isAgree || isProcessing || this.addAccountForm.invalid"
        class="add-account active tw-w-[100%] tw-h-[41px] tw-text-[16px] tw-mt-[35px]"
      >
        {{ 'account.funding.bank.add' | translate: 'Add Account' }}
      </button>
    </div>

    <img
      src="/assets/images/funding/payslip.png"
      class="tw-inline-block tw-mt-[35px]"
      width="100%"
    >

    <div class="tw-mt-[18px]">
      <!-- Copy is split at the brand so the link survives each language's word order -->
      <p class="tw-text-center tw-text-[15px]">{{ 'ui.funding.bank.add.inform3.pre' | translate }}<a href="https://amwager.com/" target="_blank" class="tw-underline">AmWager.com</a>{{ 'ui.funding.bank.add.inform3.post' | translate }}</p>

      <p class="label tw-font-bold tw-text-[15px] tw-mt-[25px] tw-mr-[8px] tw-ml-[8px]">
        {{ 'Terms and Conditions:' | translate: 'Terms and Conditions:' }}
      </p>

      <p class="tw-text-[14px] tw-mt-[15px] tw-mr-[8px] tw-ml-[8px]">
        {{ 'account.funding.bank.add.inform4' | translate }}
      </p>
    </div>

    <div class="terms-and-condition-container tw-mt-[15px] tw-mr-[8px] tw-ml-[8px]">
      <mat-checkbox
        [checked]="isAgree"
        (change)="toggleCheckbox()"
        id="termsAndCondition"
        class="active-limit tw-top-1 tw-mt-0 tw-mr-[4px] tw-mb-0">
      </mat-checkbox>
      <span
        (click)="toggleCheckbox()"
        class="agree tw-font-bold tw-text-[15px]"
      >
        {{ 'account.funding.agreeterms' | translate: 'I agree to the above terms' }}
      </span>
    </div>

  </div>
</form>
